import { MouseEvent } from "react";
import { FileData } from "../inputs/fileRow";
import { FilePreviewDisplay } from "./FilePreview";

interface Props {
  file: FileData;
}

export function FileDisplay({ file }: Props) {
  // TODO: Properly handle the case when we can only see the public data.
  const filename = file.filename$confidential ?? file.filename ?? "Unnamed";
  const isConfidential = file.url === undefined;
  const isHidden = file.url$confidential === null;
  const url = file.url$confidential ?? file.url;

  if (url === undefined) return;

  const download = (e: MouseEvent) => {
    e.preventDefault();
    if (isHidden) {
      alert("Cannot view/download this file");
    }
    // TODO
  };

  return (
    <div className="file-display">
      <div className="preview">
        <FilePreviewDisplay file={url} type={file.type}>
          <div className={file === null ? "filetype cant-decrypt" : "filetype"}>
            {file.type}
          </div>
        </FilePreviewDisplay>
      </div>

      {typeof file === "string" ? (
        <a title="Download" href={file}>
          {filename}
        </a>
      ) : (
        <a title="Download" href="#" onClick={download}>
          {filename}
        </a>
      )}
      <br />
      <span className="gray">
        {isConfidential ? " (confidential)" : " (public)"}
      </span>
    </div>
  );
}
